<div class="sort-label">{{ 'COMPANY_SEARCH.SORT_BY' | translate }}</div>

<warema-input-field class="sort-dropdown" size="small">
    <warema-dropdown name="sort-type-dropdown" [value]="sortCriteria()" (change)="sortChanged($any($event).detail)">
        @for (sortAction of searchResultSortActions; track sortAction) {
            <warema-dropdown-option [label]="sortAction.translationKey | translate" [value]="sortAction.sortType" />
        }
    </warema-dropdown>
</warema-input-field>
